import React, { useState } from 'react'
import { Card, CardGroup, Carousel, Col, Row } from 'react-bootstrap'
import VideoPlayerModal from '../common/VideoPlayerModal';

const ProductModeling = () => {

    const [modalShow, setModalShow] = useState(false);
    const [videoUrl, setVideoUrl] = useState(null)

    const openVideoModal = (data) => {
        setModalShow(true)
        setVideoUrl(data)

    }

  return (
    <>
        <Card className='product-modeling-container no-border rounded-0 container'>
            <Row className=''>
                <Col sm={12} md={4}>
                    <Card className='no-border rounded-0 container product-modeling-card'>
                        <Card.Body className='product-modeling-card-body py-2'>
                            <Card.Title className='product-modeling-card-title py-2'> Product Modeling and Animation</Card.Title>
                            {/* <Card.Subtitle className="mb-2 product-modeling-card-subtitle py-2"> Cannon Video </Card.Subtitle> */}
                            <Card.Text className="product-modeling-card-body-text py-1">
                            In addition to large ecommerce operations, other physical product companies can benefit from photography replacement using 3D models. 
                            <br /> 
                            <br /> For some products, traditional static photos don’t do them justice. Showing high - quality, detailed images is important for marketing, advertising, and sales, and photography replacement can provide more options than standard photography. 
                            <br /> 
                            <br /> 3D product models can be used to create videos that animate and highlight the features, functions, interior components and other details of products in ways not possible through traditional photography alone.                            
                            </Card.Text>
                            <div className='product-border py-2'></div>
                        </Card.Body>
                    </Card>
                </Col>
                <Col sm={12} md={8} className="product-modeling-video-list">
                    <Carousel className='product-carousel' variant="dark" fade indicators={false} interval={null}>
                        <Carousel.Item >
                        <CardGroup className='row'>
                            <Card className='no-border rounded-0 p-md-3 p-1 col-4'>
                                <Card className='product-video-section' onClick={() => openVideoModal('Canon_3D Modeling.mp4')}>
                                    <Card.Img src={process.env.PUBLIC_URL + "assets/product-modeling/thumbnails/canon.jpg"} />
                                    <Card.ImgOverlay>
                                        <Card.Img src={process.env.PUBLIC_URL + "assets/icons/video-player.png"} />
                                    </Card.ImgOverlay>
                                </Card>
                                
                                <Card.Title className='pt-3 pb-0 product-modeling-list-footer'>Cannon Camera</Card.Title>
                            </Card>
                            <Card className='no-border rounded-0 p-md-3 p-1 col-4'>
                                <Card className='product-video-section' onClick={() => openVideoModal('AmeriChip_Selfie_Light.mp4')}>
                                <Card.Img src={process.env.PUBLIC_URL + "assets/product-modeling/thumbnails/selfie-light.jpg"} />
                                    <Card.ImgOverlay>
                                        <Card.Img src={process.env.PUBLIC_URL + "assets/icons/video-player.png"} />
                                    </Card.ImgOverlay>
                                </Card>
                                <Card.Title className='pt-3 pb-0 product-modeling-list-footer'>Selfie Light</Card.Title>
                            </Card>
                            <Card className='no-border rounded-0 p-md-3 p-1 col-4'>
                                <Card className='product-video-section' onClick={() => openVideoModal('AmeriChip_Wireless_Charger.mp4')}>
                                    <Card.Img src={process.env.PUBLIC_URL + "assets/product-modeling/thumbnails/charger.jpg"} />
                                    <Card.ImgOverlay>
                                        <Card.Img src={process.env.PUBLIC_URL + "assets/icons/video-player.png"} />
                                    </Card.ImgOverlay>
                                </Card>
                                <Card.Title className='pt-3 pb-0 product-modeling-list-footer'>Wireless Charger</Card.Title>
                            </Card>
                        </CardGroup>
                        </Carousel.Item>
                        <Carousel.Item >
                        <CardGroup className='row'>
                            
                        <Card className='no-border rounded-0 p-md-3 p-1 col-4'>
                                <Card className='product-video-section' onClick={() => openVideoModal('AmeriChip_Selfie_Light.mp4')}>
                                    <Card.Img src={process.env.PUBLIC_URL + "assets/product-modeling/thumbnails/selfie-light.jpg"} />
                                    <Card.ImgOverlay>
                                        <Card.Img src={process.env.PUBLIC_URL + "assets/icons/video-player.png"} />
                                    </Card.ImgOverlay>
                                </Card>
                                <Card.Title className='pt-3 pb-0 product-modeling-list-footer'>Selfie Light</Card.Title>
                            </Card>
                            <Card className='no-border rounded-0 p-md-3 p-1 col-4'>
                                <Card className='product-video-section' onClick={() => openVideoModal('AmeriChip_Wireless_Charger.mp4')}>
                                    <Card.Img src={process.env.PUBLIC_URL + "assets/product-modeling/thumbnails/charger.jpg"} />
                                    <Card.ImgOverlay>
                                        <Card.Img src={process.env.PUBLIC_URL + "assets/icons/video-player.png"} />
                                    </Card.ImgOverlay>
                                </Card>
                                <Card.Title className='pt-3 pb-0 product-modeling-list-footer'>Wireless Charger</Card.Title>
                            </Card>
                            <Card className='no-border rounded-0 p-md-3 p-1 col-4'>
                                <Card className='product-video-section' onClick={() => openVideoModal('Canon_3D Modeling.mp4')}>
                                    <Card.Img src={process.env.PUBLIC_URL + "assets/product-modeling/thumbnails/canon.jpg"} />
                                    <Card.ImgOverlay>
                                        <Card.Img src={process.env.PUBLIC_URL + "assets/icons/video-player.png"} />
                                    </Card.ImgOverlay>
                                </Card>
                                <Card.Title className='pt-3 pb-0 product-modeling-list-footer'>Cannon Camera</Card.Title>
                            </Card>
                        </CardGroup>
                        </Carousel.Item>
                        <Carousel.Item >
                        <CardGroup className='row'>
                            <Card className='no-border rounded-0 p-md-3 p-1 col-4'>
                                <Card className='product-video-section' onClick={() => openVideoModal('AmeriChip_Wireless_Charger.mp4')}>
                                    <Card.Img src={process.env.PUBLIC_URL + "assets/product-modeling/thumbnails/charger.jpg"} />
                                    <Card.ImgOverlay>
                                        <Card.Img src={process.env.PUBLIC_URL + "assets/icons/video-player.png"} />
                                    </Card.ImgOverlay>
                                </Card>
                                <Card.Title className='pt-3 pb-0 product-modeling-list-footer'>Wireless Charger</Card.Title>
                            </Card>
                            <Card className='no-border rounded-0 p-md-3 p-1 col-4'>
                                <Card className='product-video-section' onClick={() => openVideoModal('Canon_3D Modeling.mp4')}>
                                    <Card.Img src={process.env.PUBLIC_URL + "assets/product-modeling/thumbnails/canon.jpg"} />
                                    <Card.ImgOverlay>
                                        <Card.Img src={process.env.PUBLIC_URL + "assets/icons/video-player.png"} />
                                    </Card.ImgOverlay>
                                </Card>
                                <Card.Title className='pt-3 pb-0 product-modeling-list-footer'>Cannon Camera</Card.Title>
                            </Card>
                            <Card className='no-border rounded-0 p-md-3 p-1 col-4'>
                                <Card className='product-video-section'  onClick={() => openVideoModal('AmeriChip_Selfie_Light.mp4')}>
                                    <Card.Img src={process.env.PUBLIC_URL + "assets/product-modeling/thumbnails/selfie-light.jpg"} />
                                    <Card.ImgOverlay>
                                        <Card.Img src={process.env.PUBLIC_URL + "assets/icons/video-player.png"} />
                                    </Card.ImgOverlay>
                                </Card>
                                <Card.Title className='pt-3 pb-0 product-modeling-list-footer'>Selfie Light</Card.Title>
                            </Card>
                        </CardGroup>
                        </Carousel.Item>

                    </Carousel>
                </Col>
            </Row>
        </Card>

        <VideoPlayerModal
        show={modalShow}
        onHide={() => setModalShow(false)}
        videosrc={'/assets/product-modeling/videos/' + videoUrl}
      />
    </>
  )
}

export default ProductModeling
